import { useState } from "react";
import { AllRoutes } from "../src/routes/AllRoutes.js";
import "./App.css";
import { Footer , Header } from "./components";
import { Sidebar } from './pages/Home/components/SideBar.jsx' 

function App() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  return (
 
    <div className="App dark:bg-dark_bg" >
      <Header />
      <div className="">
      <button
          onClick={toggleSidebar}
          className="fixed top-20 left-4 z-30 bg-blue-500 text-white p-2 rounded-full shadow-lg"
        >
          {isSidebarOpen ? '✕' : '☰'}
        </button>
        <Sidebar isOpen={isSidebarOpen} />
      <AllRoutes /> 
      </div>
      <Footer />
    </div>
  
  );
}

export default App;
